import {XhAnonymizationDataService} from "./service/api/xh-anonymization-data.service";
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";

export const XH_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['xh.AnonymizationData', {route: '/xx/xxAnonymizationDatas', service: XhAnonymizationDataService}],

        ] as EntityServiceEntry[],
        multi: true
    }
];
